export const checkValueToNotNull = (value) => {
	if (value === null || value === undefined) {
		return ``
	}
	return value
}
